import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import ImageFluid from '../components/imageFluid';
import { useTranslation } from 'react-i18next';
import './investigation.css';

const Investigation = () => {
  const { t} = useTranslation();

  return(
    <Layout>
      <SEO title={t('RESEARCH_SEO_TITLE')} description={t('RESEARCH_SEO_DESCRIPTION')} />
      <div className="primary-img__container">
        <ImageFluid queryName="investigationHead" alt="Investigación y desarrollo" />
        <h1>{t('RESEARCH_HEAD-H1')}</h1>
      </div>
      <div className="main__container">
        <section>
          <p>{t('RESEARCH_MAIN-P1')}</p>
          <p>{t('RESEARCH_MAIN-P2')}</p>
          <p>{t('RESEARCH_MAIN-P3')}</p>
          <p>{t('RESEARCH_MAIN-P4')}</p>
        </section>
        <section>
          <h2>{t('RESEARCH_PARKS-H2')}</h2>
          <div className="secondary-img">
            <ImageFluid queryName="investigationParqueEolico" alt="Parques eólicos" />
          </div>
          <p>{t('RESEARCH_PARKS-P1')}</p>
          <p>{t('RESEARCH_PARKS-P2')}</p>
          <p>{t('RESEARCH_PARKS-P3')}</p>
          <p>{t('RESEARCH_PARKS-P4')}</p>
          <div className="windfarms-advantages">
            <h3>{t('RESEARCH_WINDFARMS-H3')}</h3>
            <ul className="windfarms-advantages__list">
              <li>{t('RESEARCH_WINDFARMS-LI1')}</li>
              <li>{t('RESEARCH_WINDFARMS-LI2')}</li>
              <li>{t('RESEARCH_WINDFARMS-LI3')}</li>
              <li>{t('RESEARCH_WINDFARMS-LI4')}</li>
              <li>{t('RESEARCH_WINDFARMS-LI5')}</li>
              <li>{t('RESEARCH_WINDFARMS-LI6')}</li>
              <li>{t('RESEARCH_WINDFARMS-LI7')}</li>
              <li>{t('RESEARCH_WINDFARMS-LI8')}</li>
              <li>{t('RESEARCH_WINDFARMS-LI9')}</li>
              <li>{t('RESEARCH_WINDFARMS-LI10')}</li>
              <li>{t('RESEARCH_WINDFARMS-LI11')}</li>
            </ul>
          </div>
        </section>

        <section>
          <h2>{t('RESEARCH_BIOMASS-H2')}</h2>
          <div className="secondary-img">
            <ImageFluid queryName="investigationPlantaBiomasa" alt="Plantas de biomasa" />
          </div>
          <p>{t('RESEARCH_BIOMASS-P1')}</p>
        </section>

        <section>
          <h2>{t('RESEARCH_BIOCOMB-H2')}</h2>
          <div className="secondary-img">
            <ImageFluid queryName="investigationBiocombustible" alt="Plantas de biocombustible" />
          </div>
          <p>{t('RESEARCH_BIOCOMB-P1')}</p>
          <p>{t('RESEARCH_BIOCOMB-P2')}</p>
          <p>{t('RESEARCH_BIOCOMB-P3')}</p>
        </section>

      </div>  
    </Layout>
  )
}

export default Investigation